import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils';
export const QuizLogo = (props: ComponentPropsWithoutRef<'picture'> & {
  onlySymBole?: boolean;
  showFullLogoFromTabletSm?: boolean;
}) => {
  const {
    onlySymBole,
    showFullLogoFromTabletSm,
    className,
    ...rest
  } = props;
  const symbolMaxWidth = showFullLogoFromTabletSm ? 767 : 1023;
  const fullLogoMinWidth = showFullLogoFromTabletSm ? 768 : 1024;

  //
  return <picture className={cn(['size-[36px] min-h-[32px] min-w-[32px] cursor-pointer', !onlySymBole && 'tablet-lg:h-[32px] tablet-lg:min-h-[28px] tablet-lg:w-[146.125px] tablet-lg:min-w-[146.125px] ', className])} {...rest} data-sentry-element="picture" data-sentry-component="QuizLogo" data-sentry-source-file="QuizLogo.tsx">
      {onlySymBole ? <>
          <source className={className} srcSet="/assets/logo_small_q.svg" />
          <img src="/assets/logo_small_q.svg" alt="Logo" className="h-[40px]" />
        </> : <>
          <source className={className} srcSet="/assets/logo_small_q.svg" media={`(max-width: ${symbolMaxWidth}px)`} />
          <source className={className} srcSet="/assets/ZEPQuiz-logo.svg" media={`(min-width: ${fullLogoMinWidth}px)`} />
          <img className="size-full" src="/assets/ZEPQuiz-logo.svg" alt="Logo" />
        </>}
    </picture>;
};